import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const UPSELL_CONTEXT_SYMBOL = Symbol();
const useUpsell = ()=>useImmutableContext(UPSELL_CONTEXT_SYMBOL);
const useUpsellProvider = (...args)=>useImmutableContextProvider(UPSELL_CONTEXT_SYMBOL, ...args);
export { useUpsell, useUpsellProvider };
